import { BlockType } from '../models/block-type.enum';
import { BlockModel } from '../models/block.model';

/** Validate the new container without changing historical ordinary-parent contracts. */
export function validateLoopParents(blocks: BlockModel[]): void {
  const fail = (message: string): never => {
    throw new Error(`SURVEY_LOOP_CONFIGURATION_INVALID: ${message}`);
  };
  for (const parent of blocks.filter((block) => block.type === BlockType.LoopParent)) {
    const childIds = parent.groupedBlockIds;
    if (!Array.isArray(childIds) || new Set(childIds).size !== childIds.length) {
      fail('Loop parent children must be distinct block IDs');
    }
    for (const field of [
      'sourceQId',
      'sourceType',
      'sourceOptions',
      'sourceMedia',
      'allocation',
      'stimulusQuestionIds',
      'lastSourceIndex',
      'sourceOptionsRandomizedInd',
      'evenDistributionInd',
      'evenDistributionQuantity',
      'quotas'
    ]) {
      const value = parent[field];
      // Empty legacy form defaults carry no source or allocation configuration.
      const emptyDefault =
        value === undefined ||
        value === null ||
        (field === 'sourceQId' && value === '') ||
        (['sourceOptionsRandomizedInd', 'evenDistributionInd'].includes(field) && value === false) ||
        (['sourceOptions', 'sourceMedia', 'stimulusQuestionIds', 'quotas'].includes(field) && Array.isArray(value) && value.length === 0);
      if (!emptyDefault) {
        fail(`Loop parent ${parent.id} cannot configure ${field}`);
      }
    }
    const descendantIds = new Set<string>();
    for (const id of childIds) {
      const child = blocks.find((block) => block.id === id);
      if (!child || child.type !== BlockType.Loop || child.groupedBlockIds?.length) {
        fail(`Loop parent ${parent.id} accepts only leaf Loop children: ${id}`);
      }
      if (blocks.filter((block) => block.groupedBlockIds?.includes(id)).length !== 1) {
        fail(`Loop child ${id} must have exactly one parent`);
      }
      for (const questionId of child.groupedQuestionIds ?? []) {
        descendantIds.add(questionId);
      }
    }
    // Existing editor models may derive a parent's question list from its descendants.
    if ((parent.groupedQuestionIds ?? []).some((id) => !descendantIds.has(id))) {
      fail(`Loop parent ${parent.id} cannot own questions directly`);
    }
    if (blocks.some((block) => block.groupedBlockIds?.includes(parent.id))) {
      fail(`Loop parent ${parent.id} cannot be nested inside another block`);
    }
  }
}
